export default __webpack_public_path__ + "static/media/559.8c2d819f.png";